<template>
    <div>
        <p class="loading text-center pt-5" v-if="loader.firstLoading">
            <i class="fas fa-spinner fa-spin" style="font-size:2rem"></i>
        </p>

        <div v-else>
            <div v-if="loader.rows.length">

                <base-table type="hover" :data="loader.rows">

                    <template slot="columns">
                        <th width="50px"></th>
                        <th>{{ $t('xapi.common.name') }} / {{ $t('xapi.common.id') }}</th>
                        <th>{{ $t('xapi.common.type') }}</th>
                        <th class="text-right"></th>
                    </template>

                    <template slot-scope="{row}">

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null" 
                            @click="open(row)" 
                            class="td-actions"
                        >
                            <div class="index text-warning">
                                {{ row.index }}
                            </div>
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null"
                            @click="open(row)"
                        >
                            {{ row.name }}
                            <div><small>{{ row.id }}</small></div>
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null"
                            @click="open(row)"
                        >
                            {{ row.type }}
                        </td>

                        <td class="text-right" 
                            @mouseover="hovered=row.index"
                            @mouseleave="hovered=null"
                            @click="open(row)"
                        >
                            <div>
                                <a href="#" @click.prevent.stop="openStatements(row)">
                                    {{ $t('xapi.common.statements') }}
                                </a>
                            </div>
                            <div>
                                <a href="#" @click.prevent.stop="openProfiles(row)">
                                    {{ $t('xapi.common.profiles') }}
                                </a>
                            </div>
                        </td>

                    </template>

                </base-table>

                <div slot="footer" class="text-center mt-3" v-if="loader.hasMore()">
                    <base-button round type="primary" :loading="loader.nextLoading" @click="loader.nextLoad()">
                        {{ $t('common.load-more') }}
                    </base-button>
                </div>

            </div>
            
            <div v-else>
                <p class="text-center pt-3">{{ $t('xapi.common.search.no-result') }}</p>
            </div>

        </div>

        <portal to="modals">

            <modal class="fullscreen" :title="'#'+index" title-color="warning" v-model="modals.viewer">
                <json-viewer :data="selected"></json-viewer>
            </modal>

        </portal>
    </div>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'

    export default {

        data() {
            return {
                loader: this.$xapi.loaders.activities,
                filters: this.$xapi.filters.activities,
                modals: new ModalsController('viewer'),
                hovered: null,
                selected: null,
                index: null,
            }
        },

        created() {
            this.loader.setMapData(this.mapData)
            this.loader.firstLoad()
        },

        methods: {

            mapData(item, index) {
                return {
                    index: index + 1,
                    data: item.data,
                    name: this.name(item),
                    id: item.iri,
                    type: this.type(item),
                }
            },

            name(item) {
                let name = ''
                if (item.data.definition && item.data.definition.name) {
                    let keys = Object.keys(item.data.definition.name)
                    name = item.data.definition.name[keys.shift()]
                }
                return name
            },

            type(item) {
                let type = ''
                if (item.data.definition && item.data.definition.type) {
                    type = String(item.data.definition.type).split('/').pop()
                }
                return type
            },

            open(row) {
                this.selected= row.data
                this.index = row.index
                this.modals.open('viewer')
            },

            openStatements(row) {
                this.$xapi.filters.statements.reset()
                this.$xapi.filters.statements.object = row.id
                this.$router.push({ name: 'statements' })
            },

            openProfiles(row) {
                this.$xapi.filters.activityProfiles.reset()
                this.$xapi.filters.activityProfiles.activityId = row.id
                this.$router.push({ name: 'activity-profiles' })
            }
        }
    }
</script>

<style scoped>

    td:hover {
        cursor: pointer;
    }
    td .index {
        width: 30px;
        height: 30px;
        text-align: center;
        padding-top: 5px;
    }

</style>